import React, { useEffect, useState } from "react";
import { STUDENT_ROLE, offerStatuses } from "../../constants";

import OfferCard from "../offer-card";
import { fetchOfferDetail } from "../../services/offers";

export const StudentOfferCard = ({
  message,
  updateOfferStatus,
  currentUser,
  loading,
}) => {
  let messageCopy = { ...message };
  // let parseOfferDetail = message?.offerDetail;
  const [offerDetail, setOfferDetail] = useState("");
  const [offerDetailLoading, setOfferDetailLoading] = useState(true);
  useEffect(() => {
    getOfferDetail(message?.offerDetail?.offerId);
  }, [message]);

  const getOfferDetail = async (offerId) => {
    try {
      const { data, status } = await fetchOfferDetail(offerId);
      if (status === 200) {
        if (data?.data) {
          setOfferDetail(data?.data);
        }
      }
      setOfferDetailLoading(false);
    } catch (error) {
      setOfferDetailLoading(false);
    }
  };

  return (
    <div className="text-white">
      <OfferCard offerDetail={message?.offerDetail} />
      {/* <div className="d-flex justify-content-end">
        {currentUser?.role === STUDENT_ROLE ? (
          <>
            <button
              disabled={
                offerDetailLoading ||
                loading ||
                offerDetail?.status === offerStatuses.WITH_DRAWN ||
                offerDetail?.status === offerStatuses.ACCEPTED ||
                offerDetail?.status === offerStatuses.REJECTED
              }
              onClick={() => {
                updateOfferStatus(
                  message?.chatId,
                  message?.messageId,
                  offerStatuses.WITH_DRAWN,
                  messageCopy
                );
              }}
              type="button"
              className={`btn ${
                offerDetail?.status === offerStatuses.WITH_DRAWN ||
                offerDetail?.status === offerStatuses.ACCEPTED ||
                offerDetail?.status === offerStatuses.REJECTED
                  ? "btn-secondary"
                  : "btn-primary"
              }  btn-sm me-2`}
            >
              {offerDetail?.status !== offerStatuses.PENDING
                ? `Offer ${offerDetail?.status}`
                : "Withdraw Offer"}
            </button>
          </>
        ) : (
          <>
            {offerDetail?.status === offerStatuses.WITH_DRAWN ? (
              <button
                disabled={true}
                type="button"
                className="btn btn-secondary  btn-sm me-2"
              >
                {`Offer ${offerDetail?.status}`}
              </button>
            ) : offerDetail?.status === offerStatuses.ACCEPTED ? (
              <button
                disabled={true}
                type="button"
                className="btn btn-secondary  btn-sm me-2"
              >
                {`Offer ${offerDetail?.status}`}
              </button>
            ) : offerDetail?.status === offerStatuses.REJECTED ? (
              <button
                disabled={true}
                type="button"
                className="btn btn-secondary  btn-sm me-2"
              >
                {`Offer ${offerDetail?.status}`}
              </button>
            ) : (
              <>
                <button
                  disabled={
                    offerDetailLoading ||
                    loading ||
                    offerDetail?.status === offerStatuses.WITH_DRAWN ||
                    offerDetail?.status === offerStatuses.ACCEPTED ||
                    offerDetail?.status === offerStatuses.REJECTED
                  }
                  onClick={() => {
                    updateOfferStatus(
                      message?.chatId,
                      message?.messageId,
                      offerStatuses.ACCEPTED,
                      messageCopy
                    );
                  }}
                  type="button"
                  className="btn btn-primary  btn-sm me-2"
                >
                  {offerDetail?.status === offerStatuses.ACCEPTED
                    ? `Offer ${offerDetail?.status}`
                    : "Accept"}
                </button>
                <button
                  disabled={
                    offerDetailLoading ||
                    loading ||
                    offerDetail?.status === offerStatuses.WITH_DRAWN ||
                    offerDetail?.status === offerStatuses.ACCEPTED ||
                    offerDetail?.status === offerStatuses.REJECTED
                  }
                  onClick={() => {
                    updateOfferStatus(
                      message?.chatId,
                      message?.messageId,
                      offerStatuses.REJECTED,
                      messageCopy
                    );
                  }}
                  type="button"
                  className="btn btn-secondary  btn-sm me-2"
                >
                  {offerDetail?.status === offerStatuses.REJECTED
                    ? `Offer ${offerDetail?.status}`
                    : "Reject"}
                </button>
              </>
            )}
          </>
        )}
      </div> */}
    </div>
  );
};
